import PropTypes from 'prop-types';

import isEmpty from 'lodash/fp/isEmpty';
import map from 'lodash/fp/map';
import sumBy from 'lodash/fp/sumBy';

import { styled } from '@prose-ui/legacy';

import TicketLineV2 from 'Components/TicketLineV2';

import CouponShape from 'PropTypes/couponShape';

import { formatPriceWithCurrency } from 'utils/currencies';

const DiscountsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const TicketDiscountsV2 = ({
  creditCoupons,
  currency,
  hasSubscription,
  offerCoupons,
  subscriptionCoupons,
}) => {
  const totalDiscounts = [
    ...(hasSubscription ? subscriptionCoupons : []),
    ...offerCoupons,
    ...creditCoupons,
  ];

  const totalDiscountValue = sumBy('value', totalDiscounts);

  if (isEmpty(totalDiscounts)) {
    return null;
  }

  return (
    <>
      {totalDiscountValue && (
        <TicketLineV2
          currency={currency}
          dataTestId="ticket-total-discount-line-v2"
          label={totalDiscounts.length === 1 ? totalDiscounts[0].label : 'Discounts'}
          price={`-${formatPriceWithCurrency({
            price: Math.abs(
              totalDiscounts.length === 1 ? totalDiscounts[0].value : totalDiscountValue
            ).toFixed(2),
            currency,
          })}`}
        />
      )}

      {/* Discount content */}
      {totalDiscounts.length > 1 && (
        <DiscountsWrapper
          aria-labelledby="discounts-title"
          data-testid="ticket-discounts-content-v2"
          id="ticket-discounts-content-v2"
        >
          {/* Subscription discount */}
          {map(({ label, value }) => (
            <TicketLineV2
              key={label}
              currency={currency}
              isDiscountLine
              label={label}
              price={`-${formatPriceWithCurrency({ price: Math.abs(value), currency })}`}
            />
          ))(totalDiscounts)}
        </DiscountsWrapper>
      )}
    </>
  );
};

TicketDiscountsV2.propTypes = {
  creditCoupons: PropTypes.arrayOf(CouponShape),
  currency: PropTypes.string.isRequired,
  hasSubscription: PropTypes.bool.isRequired,
  offerCoupons: PropTypes.arrayOf(CouponShape),
  subscriptionCoupons: PropTypes.arrayOf(CouponShape),
};

TicketDiscountsV2.defaultProps = {
  creditCoupons: [],
  offerCoupons: [],
  subscriptionCoupons: [],
};

export default TicketDiscountsV2;
